import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSplitSurfaceProps, getSurfaceProps } from './surface.utils.js';

const SurfaceImpl = forwardRef(({ color, focusWithin, disableECOutline, children, ...props }, ref) => {
    const { paintProps } = getSplitSurfaceProps({ color, focusWithin, disableECOutline }, props);
    return (jsx("div", { "data-fpl-component": "", ...paintProps, ref: ref, children: children }));
});
SurfaceImpl.displayName = 'Surface';
/**
 * Applies semantic backgrounds and descendant color-token treatments to a subtree.
 * Surface is presentational and should not be made interactive with event handlers, roles, or
 * tabIndex. It can respond when a descendant receives focus; apply Surface.getProps to a semantic
 * FPL primitive for hover and pressed treatments.
 */
const Surface = Object.assign(SurfaceImpl, {
    getProps: getSurfaceProps,
    getSplitProps: getSplitSurfaceProps,
});

export { Surface };
//# sourceMappingURL=surface.js.map
